import { Box, Typography } from '@mui/material';

interface AtAGlanceProps {
  children?: React.ReactNode;
  hrefUrl?: string;
  headerText?: string;
}

export default function AtAGlance({
  hrefUrl,
  children,
  headerText,
}: AtAGlanceProps) {
  const homeSiteUrl = process.env.NEXT_PUBLIC_HOMESITE_URL;

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: '#f0f5f8',
        borderLeft: '5px solid #01456c',
        borderRadius: 3,
        mb: 4,
      }}
    >
      {/* Schema Metadata */}
      <link itemProp="mainEntityOfPage" href={hrefUrl} />

      <Box
        component="div"
        itemProp="image"
        itemScope
        itemType="https://schema.org/ImageObject"
        sx={{ display: 'none' }}
      >
        <meta
          itemProp="url"
          content={`${homeSiteUrl}assets/images/logo.webp`}
        />
        <meta itemProp="width" content="380" />
        <meta itemProp="height" content="124" />
      </Box>

      {/* Dynamic Header */}
      <Typography
        variant="h2"
        //  itemProp="headline"
        sx={{
          fontWeight: 600,
          mb: 1,
          fontSize: { md: 20, sm: 18, xs: 16 },
          color: '#01456c',
          fontStyle: 'italic',
        }}
      >
        {headerText}
      </Typography>

      {/* Dynamic Body */}
      {children}

      {/* Publisher */}
      <Box
        component="footer"
        itemProp="publisher"
        itemScope
        itemType="https://schema.org/Organization"
        sx={{ display: 'none' }}
      >
        <meta itemProp="name" content="TaxZerone" />

        <Box
          component="div"
          itemProp="logo"
          itemScope
          itemType="https://schema.org/ImageObject"
        >
          <meta
            itemProp="url"
            content={`${homeSiteUrl}assets/images/logo.webp`}
          />
          <meta itemProp="width" content="380" />
          <meta itemProp="height" content="124" />
        </Box>
      </Box>
    </Box>
  );
}
